<template>
  <div>
    <choose-component-transform-or-link :items='types'
                                        @next='$emit("next")'
                                        :enable-categories='true'
                                        :categories='categories'
                                        @select='selectComponentType' />
  </div>
</template>
<script>
import ChooseComponentTransformOrLink from '@ui/molecules/ChooseComponentTransformOrLink.vue';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import * as IconMapping from '@components/iconMapping.js';
export default {
  data() {
    const types = ComponentsDb.typeList.filter( (type) => {
      return (!type.toplevel || type.showInComponentView) && !type.hidden && type.level === ComponentsDb.NOOB_LEVEL;
    }).map( (type) => {
      const icon = IconMapping.default[type.type];
      let category = type.category;
      if (!category) {
        category = ComponentsDb.categories.misc;
      } else {
        category = category;
      }
      return {
        icon,
        ...type,
        category
      }
    });
    
    const categories = ComponentsDb.categories;
    return {
      types,
      categories
    }
  },
  components:{
    ChooseComponentTransformOrLink
  },
  methods: {
    selectComponentType(in_type) {
      const component = ComponentsDb.typeList.filter( (type) => {
        return type.type === in_type;
      })[0];
      this.$emit('select', {
        component
      })
    }
  }
}
</script>

